<script>
import $ from 'domtastic';
import eventHub from 'viralstyle-ui/src/eventHub';
import storage from 'viralstyle-ui/src/storage';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import hateoas from 'viralstyle-ui/src/hateoas';
import mixins from 'sales-flow-ui/utils/mixins';
import VueScript2 from 'vue-script2';
import VsToaster from 'viralstyle-ui/src/VsToaster';
import BuyerButton from 'sales-flow-ui/components/BuyerButton';
import { mapState } from 'vuex';

import config from 'config';
import VsHeader from 'components/Header';
import VsFooter from 'components/Footer';
import ZopIm from 'components/ZopIm';
import Impersonation from 'components/Impersonation';

export default {
  components: {
    VsToaster,
    VsHeader,
    VsFooter,
    ZopIm,
    BuyerButton,
    Impersonation,
  },
  mixins: [mixins],
  data: () => ({
    cartInitialized: false,
  }),
  computed: {
    ...mapState(['ready', 'lockScroll', 'notifications', 'processing', 'currencyInfo', 'campaignErrorInfo']),
    ...mapState({
      campaign: state => state.sales.campaign,
      cart: state => state.cart.cart,
      showUsOnlyMessage: state => state.cart.showUsOnlyMessage,
      customer: state => state.checkout.customer,
    }),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md';
    },
    onSalesPage() {
      return this.$route.name === 'sales';
    },
    showEmailValidatedMessage() {
      return get(this.$route, 'query.email_validated') === '1';
    },
  },
  watch: {
    async $route(to, from) {
      let excludedRoutes = ['sales', 'checkout', 'thankYou', 'store', 'cart', 'paypalUpsell', 'paypal', 'collection', 'marketplaceRoot'],
        accountRoutes = ['signIn', 'signUp', 'signUpPartner', 'resetPassword', 'forgotPassword', 'terms', 'privacy'],
        redirectRoutes = ['sales', 'checkout', 'cart', 'paypal', 'paypalUpsell', 'designer', 'designerDraft'],
        toAndFromMarketplace = to.name === 'marketplace' && from.name === 'marketplace',
        toAndFromCollection = to.name === 'collection' && from.name === 'collection';

      if (get(this.$route, 'name') && !excludedRoutes.includes(this.$route.name)) {
        this.$store.dispatch('viewPage');
      }

      this.$store.commit('lockScroll', false);

      if (to.name !== 'marketplace') {
        this.$store.commit('resetMarketplaceFilters');
      }

      if (to.name === 'sales' && this.cartInitialized) {
        this.$_storeAffiliate();
      }

      if (accountRoutes.includes(to.name) && redirectRoutes.includes(from.name)) {
        this.$store.commit('updateState', { object: this.$store.state.account, property: 'redirect', value: from });
      } else if (!(accountRoutes.includes(to.name) && accountRoutes.includes(from.name) && isObject(this.$store.state.account.redirect))) {
        this.$store.commit('updateState', { object: this.$store.state.account, property: 'redirect', value: true });
      }

      if ((!this.onSalesPage || (this.onSalesPage && to.hash === from.hash)) && (!toAndFromCollection && !toAndFromMarketplace)) {
        window.scrollTo(0, 0);
      }
    },
  },
  async created() {
    let params = new URLSearchParams(window.location.search);

    if (params.get('return')) {
      await this.$store.dispatch('logout');
    }

    if (this.$route.name === 'home') {
      this.$store.dispatch('viewPage');
    }

    await this.$store.dispatch('getApiRoutes');

    this.$store.dispatch('getMarketplaceFilters');

    this.$store.commit('applicationReady', true);

    if (this.$route.name === 'cart' && this.$route.params.id) {
      storage.set('cart', hateoas.url('get_cart', { cartId: this.$route.params.id }));
    }

    if (storage.get('cart') && !this.cart.items.length) {
      try {
        await this.$store.dispatch('getCart');

        this.$store.dispatch('getUserInfo');

        this.$_storeAffiliate();

        if (!this.cart.items.length) {
          this.applyUrlCoupon();
        }
      } catch (e) {
        if (this.$route.name === 'checkout' || this.$route.name === 'cart') {
          this.$store.dispatch('navigateToRecentCampaignOrMarketplace');
        }

        this.$store.dispatch('getUserInfo');

        this.$_storeAffiliate();
      }
    } else {
      this.$store.dispatch('getUserInfo');
      this.$_storeAffiliate();
    }

    this.$_appendGrecaptcha();
  },
  mounted() {
    $(document.body).on('keyup', this.handleEscPressed);
  },
  beforeDestroy() {
    this.$store.commit('clearUserTimeout');

    $(document.body).off('keyup', this.handleEscPressed);
  },
  methods: {
    $_appendGrecaptcha() {
      if (config.GOOGLE_RECAPTCHA_SITEKEY) {
        VueScript2.load('https://www.google.com/recaptcha/api.js?onload=grecaptchaLoaded&render=explicit');
        window.grecaptchaLoaded = () => this.$store.commit('updateState', { object: this.$store.state, property: 'grecaptchaLoaded', value: true });
      }
    },
    $_storeAffiliate() {
      if (this.$route.name === 'sales') {
        if (!this.cart.items.length) {
          let affiliateObj = storage.get('affiliate'),
            affiliateId = this.$route.query.aid;

          if (affiliateId) {
            storage.set('affiliate', { aid: affiliateId }, { storages: ['cookie'], expireDays: 60 });
          }
        }
        let query = cloneDeep(this.$route.query);

        delete query.aid;

        this.$router.replace({ name: 'sales', query, params: this.$route.params, hash: this.$route.hash }).catch(err => {});
      }

      this.cartInitialized = true;
    },
    handleEscPressed(e) {
      if (e.keyCode === 27) eventHub.$emit('esc-pressed');
    },
    handleRemoveNotification(notification) {
      this.$store.commit('removeNotification', notification);
    },
    navigateToAdminUrl(url) {
      window.location.href = url;
    },
  },
  metaInfo() {
    return {
      titleTemplate: titleChunk => titleChunk ? `${titleChunk} - Viralstyle` : 'Viralstyle',
    };
  },
};
</script>

<template lang='pug'>
.wrapper.font-archivo.relative.text-brand-secondary.overflow-x-hidden(v-if='ready')
  vs-header
  main#content
    .text-xl.text-brand.bg-brand-100.border-brand.border.p-1(v-if='showEmailValidatedMessage')
      .container.px-1.mx-auto Thank you! Your email address has been validated and you may now launch campaigns.
    keep-alive(include='DesignerRoot')
      router-view(:key='$route.name === "marketplace" ? JSON.stringify($route.query) : null')
  vs-footer(ref='footer')
  vs-toaster(:notifications='notifications', @remove-toast='handleRemoveNotification')
  .csid(v-if='$route.name === "sales"')
    template(v-if='campaign.products.length')
      buyer-button(
        v-if='campaign.admin_url',
        small,
        @click='navigateToAdminUrl(campaign.admin_url)',
      ) Admin for {{campaign.analytics_cid}}
      small(v-else) {{campaign.analytics_cid}}
    template(v-else-if='campaignErrorInfo')
      buyer-button(
        v-if='campaignErrorInfo.admin_url',
        small,
        @click='navigateToAdminUrl(campaignErrorInfo.admin_url)',
      ) Admin for {{campaignErrorInfo.campaign_id}}
      small(v-else) {{campaignErrorInfo.campaign_id}}
  zop-im
  impersonation(v-if='customer.is_impersonation')
  portal-target(name='body')
</template>

<style>
@import '~import/index';
@import '~styles/index';
@import '~styles/variables';

.no-scroll {
  overflow: hidden;
  -webkit-overflow-scrolling: auto;

  &--mobile {
    overflow: hidden;
    -webkit-overflow-scrolling: auto;

    @include mq(mf-md) {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}

.csid {
  position: absolute;
  color: $white;
  right: .5rem;
  bottom: .5rem;
}

img,
.vs-product-slider__image,
.details-upsell__image,
.campaign__image {
  opacity: 0;
  transition: opacity 500ms;
}

img[lazy=loading],
.vs-product-slider__image[lazy=loading],
.details-upsell__image[lazy=loading],
.campaign__image[lazy=loading] {
  opacity: 1;
}

img[lazy=loaded],
.vs-product-slider__image[lazy=loaded],
.details-upsell__image[lazy=loaded],
.campaign__image[lazy=loaded],
.product-details__tabs img {
  opacity: 1;
}

.loader {
  border-radius: 50%;
  animation: rotation 1.5s infinite linear;
  border-top-color: transparent;

  &.absolute {
    top: 50%;
    left: 50%;
    animation: rotation-absolute 1.5s infinite linear;
  }
}

.break-anywhere {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  80% {
    transform: rotate(200deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

@keyframes rotation-absolute {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  80% {
    transform: translate(-50%, -50%) rotate(200deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(359deg);
  }
}
</style>